import { Rule } from 'antd/es/form';
import { AppFormItemProps, AppFormRangeItem, AppTimePicker } from 'components/atoms';
import { formElementRequiredText } from 'consts/errors/forms';
import { formFields } from 'consts/form/formFields';
import { TIME_LABEL } from 'consts/labels/common';
import { journalTexts } from 'consts/text';
import { AppFormRangeItemMode } from 'types';
import { datesTimelineValidator } from 'utils/validators';

export type TopicHoursTimePickerProps = AppFormItemProps & {
    mode: AppFormRangeItemMode;
};

export const TopicHoursTimePicker = ({ mode, disabled, ...props }: TopicHoursTimePickerProps) => {
    const rules: Rule[] = [
        { required: true, message: formElementRequiredText },
        ({ getFieldValue }) =>
            datesTimelineValidator(getFieldValue, {
                mode,
                startValueFieldName: formFields.declaredStayHoursFromTime,
                finishValueFieldName: formFields.declaredStayHoursToTime,
                isFinishValueBeforeStartValueErrorText:
                    journalTexts.journalDetails.groupJournal.topics
                        .isFinishHoursBeforeStartHoursErrorText,
                isStartValueAfterFinishValueErrorText:
                    journalTexts.journalDetails.groupJournal.topics
                        .isStartHoursAfterFinishHoursErrorText,
                unitToCompare: 'minute',
            }),
    ];

    return (
        <AppFormRangeItem
            mode={mode}
            startValues={{
                label: journalTexts.journalDetails.groupJournal.topics.timeFromInputLabel,
                additionalText: TIME_LABEL,
                name: formFields.timeFrom,
                disabled: !!(mode === 'start' && disabled),
                rules,
            }}
            finishValues={{
                label: journalTexts.journalDetails.groupJournal.topics.timeToInputLabel,
                additionalText: TIME_LABEL,
                name: formFields.timeTo,
                rules,
                disabled: !!(mode === 'finish' && disabled),
            }}
            disabled={disabled}
            {...props}
        >
            <AppTimePicker autoComplete="off" disabled={disabled} />
        </AppFormRangeItem>
    );
};
